import { z } from "zod";
const nullableText = z.string().trim().min(1).nullable();
const nullableCount = z.number().int().nonnegative().nullable();
const nullableRate = z.number().nonnegative().finite().nullable();
export const modelCallUsageEvidenceSchema = z.object({
    callKey: z.string().trim().min(1),
    callIndex: z.number().int().nonnegative(),
    runtimeRole: z.enum([
        "task_agent", "plugin_router", "product_router", "resolver_evaluator",
        "retrieval_agent", "memory_curator", "session_title", "canvas_author", "canvas_fact_check", "feed_outcome", "other",
    ]),
    /**
     * What this call asked for, where it is not the run's model: a tool's own calls (the canvas
     * author's). Left out, the run's requested model stands.
     */
    requestedProvider: nullableText.optional(),
    requestedModel: nullableText.optional(),
    actualProvider: nullableText,
    actualModel: nullableText,
    responseId: nullableText,
    stopReason: nullableText,
    inputTokens: nullableCount,
    contextInputTokens: nullableCount.optional(),
    contextWindowTokens: nullableCount.optional(),
    outputTokens: nullableCount,
    reasoningTokens: nullableCount,
    cacheReadTokens: nullableCount,
    cacheWriteTokens: nullableCount,
    totalTokens: nullableCount,
    providerCostMicrousd: nullableCount,
    startedAt: z.number().int().nonnegative().optional(),
    durationMs: z.number().int().nonnegative().optional(),
    timeToFirstTokenMs: z.number().int().nonnegative().nullable().optional(),
    decodeTokensPerSecond: nullableRate.optional(),
    serverPromptMs: nullableRate.optional(),
    serverPromptTokensPerSecond: nullableRate.optional(),
    serverPredictedMs: nullableRate.optional(),
    serverPredictedTokensPerSecond: nullableRate.optional(),
    serverCachedPromptTokens: nullableCount.optional(),
    serverDraftTokens: nullableCount.optional(),
    serverDraftAcceptedTokens: nullableCount.optional(),
    serverDraftAcceptanceRate: nullableRate.optional(),
    usageAvailability: z.enum(["complete", "partial", "unavailable"]),
    unavailableReason: nullableText,
});
